// // src/components/pages/Jobs.jsx
// import React, { useState, useEffect } from 'react';
// import { Link } from 'react-router-dom';
// import storageService from '../../services/storageService';
// import { JOB_STATUS } from '../../constants/statusConstants';
// import './Jobs.css';

// const Jobs = () => {
//   const [jobs, setJobs] = useState([]);
//   const [companies, setCompanies] = useState({});
//   const [loading, setLoading] = useState(true);
//   const [showModal, setShowModal] = useState(false);
//   const [editingJob, setEditingJob] = useState(null);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [filterStatus, setFilterStatus] = useState('all');
//   const [filterCompany, setFilterCompany] = useState('all');
  
//   const [formData, setFormData] = useState({
//     title: '',
//     companyId: '',
//     description: '',
//     requirements: '',
//     experience: '',
//     salary: '',
//     status: 'Open',
//     location: '',
//     jobType: 'Full-time',
//     skills: ''
//   });

//   useEffect(() => {
//     loadData();
//   }, []);

//   const loadData = () => {
//     const allJobs = storageService.getJobs();
//     const allCompanies = storageService.getCompanies();
    
//     const companiesMap = {};
//     allCompanies.forEach(company => {
//       companiesMap[company.id] = company;
//     });
    
//     setJobs(allJobs);
//     setCompanies(companiesMap);
//     setLoading(false);
//   };

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setFormData(prev => ({ ...prev, [name]: value }));
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
    
//     if (editingJob) {
//       storageService.updateJob(editingJob.id, formData);
//     } else {
//       const jobData = {
//         ...formData,
//         createdAt: new Date().toISOString().split('T')[0]
//       };
//       storageService.createJob(jobData);
//     }
    
//     resetForm();
//     loadData();
//     setShowModal(false);
//   };

//   const handleEdit = (job) => {
//     setEditingJob(job);
//     setFormData(job);
//     setShowModal(true);
//   };

//   const handleDelete = (id) => {
//     if (window.confirm('Are you sure? This will delete all related applications.')) {
//       storageService.deleteJob(id);
//       loadData();
//     }
//   };

//   const resetForm = () => {
//     setFormData({
//       title: '',
//       companyId: '',
//       description: '',
//       requirements: '',
//       experience: '',
//       salary: '',
//       status: 'Open',
//       location: '',
//       jobType: 'Full-time',
//       skills: ''
//     });
//     setEditingJob(null);
//   };

//   // Filter jobs
//   const filteredJobs = jobs.filter(job => {
//     const matchesSearch = 
//       job.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
//       job.requirements.toLowerCase().includes(searchTerm.toLowerCase()) ||
//       job.description.toLowerCase().includes(searchTerm.toLowerCase());
    
//     const matchesStatus = filterStatus === 'all' || job.status === filterStatus;
//     const matchesCompany = filterCompany === 'all' || job.companyId === filterCompany;
    
//     return matchesSearch && matchesStatus && matchesCompany;
//   });

//   const companyOptions = Object.values(companies);
//   const openJobs = jobs.filter(job => job.status === 'Open').length;

//   if (loading) {
//     return (
//       <div className="loading-container">
//         <div className="spinner"></div>
//         <p>Loading jobs...</p>
//       </div>
//     );
//   }

//   return (
//     <div className="jobs-page">
//       {/* Page Header */}
//       <div className="page-header">
//         <div>
//           <h1>Job Requirements</h1>
//           <p>Manage job openings and requirements</p>
//         </div>
//         <button onClick={() => setShowModal(true)} className="btn-primary">
//           <span className="btn-icon">+</span> Post New Job
//         </button>
//       </div>

//       {/* Stats */}
//       <div className="stats-cards">
//         <div className="stat-card">
//           <div className="stat-icon">💼</div>
//           <div className="stat-content">
//             <h3>{jobs.length}</h3>
//             <p>Total Jobs</p>
//           </div>
//         </div>
//         <div className="stat-card">
//           <div className="stat-icon">✅</div>
//           <div className="stat-content">
//             <h3>{openJobs}</h3>
//             <p>Open Positions</p>
//           </div>
//         </div>
//         <div className="stat-card">
//           <div className="stat-icon">🏢</div>
//           <div className="stat-content">
//             <h3>{companyOptions.length}</h3>
//             <p>Companies</p>
//           </div>
//         </div>
//       </div>

//       {/* Filters */}
//       <div className="filters-section">
//         <div className="search-box">
//           <input
//             type="text"
//             placeholder="Search jobs by title, requirements, or description..."
//             value={searchTerm}
//             onChange={(e) => setSearchTerm(e.target.value)}
//             className="search-input"
//           />
//           <span className="search-icon">🔍</span>
//         </div>
        
//         <div className="filter-controls">
//           <select 
//             value={filterStatus} 
//             onChange={(e) => setFilterStatus(e.target.value)}
//             className="filter-select"
//           >
//             <option value="all">All Status</option>
//             {Object.values(JOB_STATUS).map(status => (
//               <option key={status} value={status}>{status}</option>
//             ))}
//           </select>
          
//           <select 
//             value={filterCompany} 
//             onChange={(e) => setFilterCompany(e.target.value)}
//             className="filter-select"
//           >
//             <option value="all">All Companies</option>
//             {companyOptions.map(company => (
//               <option key={company.id} value={company.id}>{company.name}</option>
//             ))}
//           </select>
//         </div>
//       </div>

//       {/* Jobs Table */}
//       <div className="table-container">
//         {filteredJobs.length > 0 ? (
//           <table className="data-table">
//             <thead>
//               <tr>
//                 <th>Job Title</th>
//                 <th>Company</th>
//                 <th>Requirements</th>
//                 <th>Experience</th>
//                 <th>Salary</th>
//                 <th>Status</th>
//                 <th>Actions</th>
//               </tr>
//             </thead>
//             <tbody>
//               {filteredJobs.map(job => (
//                 <tr key={job.id}>
//                   <td>
//                     <div className="job-title-cell">
//                       <div className="job-icon">💼</div>
//                       <div>
//                         <Link to={`/job/${job.id}/candidates`} className="job-title">
//                           {job.title}
//                         </Link>
//                         <div className="job-meta">
//                           <span className="job-location">{job.location || 'Remote'}</span>
//                           <span className="job-type">{job.jobType}</span>
//                         </div>
//                       </div>
//                     </div>
//                   </td>
//                   <td>
//                     <Link to={`/company/${job.companyId}/jobs`} className="company-link">
//                       {companies[job.companyId]?.name || 'Unknown'}
//                     </Link>
//                   </td>
//                   <td>
//                     <div className="requirements-cell">
//                       {job.requirements?.split(',').slice(0, 2).map((req, idx) => (
//                         <span key={idx} className="requirement-tag">{req.trim()}</span>
//                       ))}
//                       {job.requirements?.split(',').length > 2 && (
//                         <span className="more-tag">+{job.requirements.split(',').length - 2} more</span>
//                       )}
//                     </div>
//                   </td>
//                   <td>{job.experience || 'Not specified'}</td>
//                   <td className="salary-cell">{job.salary || 'Negotiable'}</td>
//                   <td>
//                     <span className={`status-badge ${job.status === 'Open' ? 'open' : job.status === 'Closed' ? 'closed' : 'hold'}`}>
//                       {job.status}
//                     </span>
//                   </td>
//                   <td>
//                     <div className="action-buttons">
//                       <button 
//                         onClick={() => handleEdit(job)} 
//                         className="action-btn edit"
//                         title="Edit"
//                       >
//                         ✏️
//                       </button>
//                       <Link 
//                         to={`/job/${job.id}/candidates`} 
//                         className="action-btn view"
//                         title="View Candidates"
//                       >
//                         👁️
//                       </Link>
//                       <button 
//                         onClick={() => handleDelete(job.id)} 
//                         className="action-btn delete"
//                         title="Delete"
//                       >
//                         🗑️
//                       </button>
//                     </div>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         ) : (
//           <div className="empty-state">
//             <div className="empty-icon">💼</div>
//             <h3>No jobs found</h3>
//             <p>Try posting a new job or adjust your search filters</p>
//             <button onClick={() => setShowModal(true)} className="btn-primary">
//               Post Your First Job
//             </button>
//           </div>
//         )}
//       </div>

//       {/* Add/Edit Modal */}
//       {showModal && (
//         <div className="modal-overlay">
//           <div className="modal-content">
//             <div className="modal-header">
//               <h2>{editingJob ? 'Edit Job' : 'Post New Job'}</h2>
//               <button onClick={() => { resetForm(); setShowModal(false); }} className="modal-close">
//                 ×
//               </button>
//             </div>
            
//             <form onSubmit={handleSubmit}>
//               <div className="modal-body">
//                 <div className="form-grid">
//                   <div className="form-group">
//                     <label>Job Title *</label>
//                     <input
//                       type="text"
//                       name="title"
//                       value={formData.title}
//                       onChange={handleInputChange}
//                       placeholder="e.g., Senior React Developer"
//                       required
//                       className="form-input"
//                     />
//                   </div>
                  
//                   <div className="form-group">
//                     <label>Company *</label>
//                     <select
//                       name="companyId"
//                       value={formData.companyId}
//                       onChange={handleInputChange}
//                       required
//                       className="form-select"
//                     >
//                       <option value="">Select Company</option>
//                       {companyOptions.map(company => (
//                         <option key={company.id} value={company.id}>{company.name}</option>
//                       ))}
//                     </select>
//                   </div>
                  
//                   <div className="form-group">
//                     <label>Location</label>
//                     <input
//                       type="text"
//                       name="location"
//                       value={formData.location}
//                       onChange={handleInputChange}
//                       placeholder="e.g., Remote, Mumbai, Bangalore"
//                       className="form-input"
//                     />
//                   </div>
                  
//                   <div className="form-group">
//                     <label>Job Type</label>
//                     <select
//                       name="jobType"
//                       value={formData.jobType}
//                       onChange={handleInputChange}
//                       className="form-select"
//                     >
//                       <option value="Full-time">Full-time</option>
//                       <option value="Part-time">Part-time</option>
//                       <option value="Contract">Contract</option>
//                       <option value="Internship">Internship</option>
//                     </select>
//                   </div>
                  
//                   <div className="form-group">
//                     <label>Experience *</label>
//                     <input
//                       type="text"
//                       name="experience"
//                       value={formData.experience}
//                       onChange={handleInputChange}
//                       placeholder="e.g., 3-5 years, Fresher"
//                       required
//                       className="form-input"
//                     />
//                   </div>
                  
//                   <div className="form-group">
//                     <label>Salary *</label>
//                     <input
//                       type="text"
//                       name="salary"
//                       value={formData.salary}
//                       onChange={handleInputChange}
//                       placeholder="e.g., ₹10-15 LPA, Negotiable"
//                       required
//                       className="form-input"
//                     />
//                   </div>
                  
//                   <div className="form-group">
//                     <label>Status</label>
//                     <select
//                       name="status"
//                       value={formData.status}
//                       onChange={handleInputChange}
//                       className="form-select"
//                     >
//                       {Object.values(JOB_STATUS).map(status => (
//                         <option key={status} value={status}>{status}</option>
//                       ))}
//                     </select>
//                   </div>
//                 </div>
                
//                 <div className="form-group">
//                   <label>Key Skills/Requirements *</label>
//                   <textarea
//                     name="requirements"
//                     value={formData.requirements}
//                     onChange={handleInputChange}
//                     rows="3"
//                     placeholder="List key skills separated by commas (React, JavaScript, Node.js)"
//                     required
//                     className="form-textarea"
//                   />
//                 </div>
                
//                 <div className="form-group">
//                   <label>Additional Skills</label>
//                   <input
//                     type="text"
//                     name="skills"
//                     value={formData.skills}
//                     onChange={handleInputChange}
//                     placeholder="Other relevant skills"
//                     className="form-input"
//                   />
//                 </div>
                
//                 <div className="form-group">
//                   <label>Job Description *</label>
//                   <textarea
//                     name="description"
//                     value={formData.description}
//                     onChange={handleInputChange}
//                     rows="4"
//                     placeholder="Detailed job description, responsibilities, and requirements..."
//                     required
//                     className="form-textarea"
//                   />
//                 </div>
//               </div>
              
//               <div className="modal-footer">
//                 <button type="submit" className="btn-primary">
//                   {editingJob ? 'Update Job' : 'Post Job'}
//                 </button>
//                 <button 
//                   type="button" 
//                   onClick={() => { resetForm(); setShowModal(false); }}
//                   className="btn-secondary"
//                 >
//                   Cancel
//                 </button>
//               </div>
//             </form>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default Jobs;


//13/04/2026








// src/components/pages/Jobs.jsx
// import React, { useState, useEffect, useContext } from 'react'; // Add useContext
// import { Link } from 'react-router-dom';
// import { getJobs, getCompanies, createJob, updateJob, deleteJob } from "../../services/api";
// import { JOB_STATUS } from '../../constants/statusConstants';
// import { useAuth } from "../../contexts/AuthContext"; // Change this line
// import './Jobs.css';


// const Jobs = () => {
//   // Get current user from AuthContext
// const { currentUser } = useAuth(); // Change this line
  
//   const [jobs, setJobs] = useState([]);
//   const [companies, setCompanies] = useState({});
//   const [loading, setLoading] = useState(true);
//   const [showModal, setShowModal] = useState(false);
//   const [editingJob, setEditingJob] = useState(null);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [filterStatus, setFilterStatus] = useState('all');
//   const [filterCompany, setFilterCompany] = useState('all');
  
//   // Pagination states
//   const [currentPage, setCurrentPage] = useState(1);
//   const [itemsPerPage, setItemsPerPage] = useState(10);
//   const [itemsPerPageOptions] = useState([5, 10, 25, 50, 100]);

//   // Check if user is admin
//   const isAdmin = currentUser && currentUser.role === "admin";
  
//   const [formData, setFormData] = useState({
//     title: '',
//     companyId: '',
//     description: '',
//     requirements: '',
//     experience: '',
//     salary: '',
//     status: 'Open',
//     location: '',
//     jobType: 'Full-time',
//     skills: ''
//   });

//   useEffect(() => {
//     loadData();
//   }, []);

//   // Reset to first page when filters change
//   useEffect(() => {
//     setCurrentPage(1);
//   }, [searchTerm, filterStatus, filterCompany]);

//   const loadData = async () => {

//   try {

//     const jobsRes = await getJobs();
//     const companiesRes = await getCompanies();

//     const companiesMap = {};
//     companiesRes.data.forEach(company => {
//       companiesMap[company.id] = company;
//     });

//     setJobs(jobsRes.data);
//     setCompanies(companiesMap);

//   } catch (error) {
//     console.error(error);
//   }

//   setLoading(false);
// };

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setFormData(prev => ({ ...prev, [name]: value }));
//   };

//   const handleSubmit = async (e) => {
//   e.preventDefault();

//   try {

//     if (editingJob) {
//       await updateJob(editingJob.id, formData);
//     } else {
//       await createJob(formData);
//     }

//     resetForm();
//     loadData();
//     setShowModal(false);

//   } catch (error) {
//     console.error("Error saving job:", error);
//   }
// };

//   const handleEdit = (job) => {
//     // Only admin can edit
//     if (!isAdmin) {
//       alert("You don't have permission to edit jobs");
//       return;
//     }
//     setEditingJob(job);
//     setFormData(job);
//     setShowModal(true);
//   };

//   const handleDelete = async (id) => {
//     // Only admin can delete
//     if (!isAdmin) {
//       alert("You don't have permission to delete jobs");
//       return;
//     }
//     if (window.confirm('Are you sure? This will delete all related applications.')) {
//       await deleteJob(id);
//       loadData();
//     }
//   };

//   const resetForm = () => {
//     setFormData({
//       title: '',
//       companyId: '',
//       description: '',
//       requirements: '',
//       experience: '',
//       salary: '',
//       status: 'Open',
//       location: '',
//       jobType: 'Full-time',
//       skills: ''
//     });
//     setEditingJob(null);
//   };

//   // Filter jobs
//   const filteredJobs = jobs.filter(job => {
//     const matchesSearch = 
//       job.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
//       job.requirements.toLowerCase().includes(searchTerm.toLowerCase()) ||
//       job.description.toLowerCase().includes(searchTerm.toLowerCase());
    
//     const matchesStatus = filterStatus === 'all' || job.status === filterStatus;
//     const matchesCompany = filterCompany === 'all' || job.companyId === filterCompany;
    
//     return matchesSearch && matchesStatus && matchesCompany;
//   });

//   // Pagination logic
//   const indexOfLastItem = currentPage * itemsPerPage;
//   const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//   const currentItems = filteredJobs.slice(indexOfFirstItem, indexOfLastItem);
//   const totalPages = Math.ceil(filteredJobs.length / itemsPerPage);

//   // Pagination handlers
//   const paginate = (pageNumber) => setCurrentPage(pageNumber);
  
//   const goToPreviousPage = () => {
//     if (currentPage > 1) {
//       setCurrentPage(currentPage - 1);
//     }
//   };
  
//   const goToNextPage = () => {
//     if (currentPage < totalPages) {
//       setCurrentPage(currentPage + 1);
//     }
//   };
  
//   const handleItemsPerPageChange = (e) => {
//     setItemsPerPage(Number(e.target.value));
//     setCurrentPage(1);
//   };

//   const companyOptions = Object.values(companies);
//   const openJobs = jobs.filter(job => job.status === 'Open').length;

//   if (loading) {
//     return (
//       <div className="loading-container">
//         <div className="spinner"></div>
//         <p>Loading jobs...</p>
//       </div>
//     );
//   }

//   return (
//     <div className="jobs-page">
//       {/* Page Header */}
//       <div className="page-header">
//         <div>
//           <h1>Job Requirements</h1>
//           <p>Manage job openings and requirements</p>
//           {!isAdmin && (
//             <small style={{ color: '#666', fontSize: '12px' }}>View Only Mode</small>
//           )}
//         </div>
//         <button onClick={() => setShowModal(true)} className="btn-primary">
//           <span className="btn-icon">+</span> Post New Job
//         </button>
//       </div>

//       {/* Stats */}
//       <div className="stats-cards">
//         <div className="stat-card">
//           <div className="stat-icon">💼</div>
//           <div className="stat-content">
//             <h3>{jobs.length}</h3>
//             <p>Total Jobs</p>
//           </div>
//         </div>
//         <div className="stat-card">
//           <div className="stat-icon">✅</div>
//           <div className="stat-content">
//             <h3>{openJobs}</h3>
//             <p>Open Positions</p>
//           </div>
//         </div>
//         <div className="stat-card">
//           <div className="stat-icon">🏢</div>
//           <div className="stat-content">
//             <h3>{companyOptions.length}</h3>
//             <p>Companies</p>
//           </div>
//         </div>
//       </div>

//       {/* Filters */}
//       <div className="filters-section">
//         <div className="search-box">
//           <input
//             type="text"
//             placeholder="Search jobs by title, requirements, or description..."
//             value={searchTerm}
//             onChange={(e) => setSearchTerm(e.target.value)}
//             className="search-input"
//           />
//           <span className="search-icon">🔍</span>
//         </div>
        
//         <div className="filter-controls">
//           <select 
//             value={filterStatus} 
//             onChange={(e) => setFilterStatus(e.target.value)}
//             className="filter-select"
//           >
//             <option value="all">All Status</option>
//             {Object.values(JOB_STATUS).map(status => (
//               <option key={status} value={status}>{status}</option>
//             ))}
//           </select>
          
//           <select 
//             value={filterCompany} 
//             onChange={(e) => setFilterCompany(e.target.value)}
//             className="filter-select"
//           >
//             <option value="all">All Companies</option>
//             {companyOptions.map(company => (
//               <option key={company.id} value={company.id}>{company.name}</option>
//             ))}
//           </select>
//         </div>
//       </div>

//       {/* Jobs Table with Pagination */}
//       <div className="table-container">
//         {filteredJobs.length > 0 ? (
//           <>
//             <table className="data-table">
//               <thead>
//                 <tr>
//                   <th>Job Title</th>
//                   <th>Company</th>
//                   <th>Requirements</th>
//                   <th>Experience</th>
//                   <th>Salary</th>
//                   <th>Status</th>
//                   <th>Actions</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {currentItems.map(job => (
//                   <tr key={job.id}>
//                     <td>
//                       <div className="job-title-cell">
//                         <div className="job-icon">💼</div>
//                         <div>
//                           <Link to={`/job/${job.id}/candidates`} className="job-title">
//                             {job.title}
//                           </Link>
//                           <div className="job-meta">
//                             <span className="job-location">{job.location || 'Remote'}</span>
//                             <span className="job-type">{job.jobType}</span>
//                           </div>
//                         </div>
//                       </div>
//                     </td>
//                     <td>
//                       <Link to={`/company/${job.companyId}/jobs`} className="company-link">
//                         {companies[job.companyId]?.name || 'Unknown'}
//                       </Link>
//                     </td>
//                     <td>
//                       <div className="requirements-cell">
//                         {job.requirements?.split(',').slice(0, 2).map((req, idx) => (
//                           <span key={idx} className="requirement-tag">{req.trim()}</span>
//                         ))}
//                         {job.requirements?.split(',').length > 2 && (
//                           <span className="more-tag">+{job.requirements.split(',').length - 2} more</span>
//                         )}
//                       </div>
//                     </td>
//                     <td>{job.experience || 'Not specified'}</td>
//                     <td className="salary-cell">{job.salary || 'Negotiable'}</td>
//                     <td>
//                       <span className={`status-badge ${job.status === 'Open' ? 'open' : job.status === 'Closed' ? 'closed' : 'hold'}`}>
//                         {job.status}
//                       </span>
//                     </td>
//                     <td>
//                       <div className="action-buttons">
//                         {/* Edit Button - Only visible to admin */}
//                         {isAdmin && (
//                           <button 
//                             onClick={() => handleEdit(job)} 
//                             className="action-btn edit"
//                             title="Edit"
//                           >
//                             ✏️
//                           </button>
//                         )}
                        
//                         <Link 
//                           to={`/job/${job.id}/candidates`} 
//                           className="action-btn view"
//                           title="View Candidates"
//                         >
//                           👁️
//                         </Link>
                        
                        
//                         {/* Delete Button - Only visible to admin */}
//                         {isAdmin && (
//                           <button 
//                             onClick={() => handleDelete(job.id)} 
//                             className="action-btn delete"
//                             title="Delete"
//                           >
//                             🗑️
//                           </button>
//                         )}
//                       </div>
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>

//             {/* Pagination Controls */}
//             <div className="pagination-container">
//               <div className="pagination-info">
//                 Showing {indexOfFirstItem + 1} to {Math.min(indexOfLastItem, filteredJobs.length)} of {filteredJobs.length} entries
//               </div>
              
//               <div className="pagination-controls">
//                 <div className="items-per-page">
//                   <label>Show:</label>
//                   <select 
//                     value={itemsPerPage} 
//                     onChange={handleItemsPerPageChange}
//                     className="items-per-page-select"
//                   >
//                     {itemsPerPageOptions.map(option => (
//                       <option key={option} value={option}>{option}</option>
//                     ))}
//                   </select>
//                 </div>
                
//                 <div className="pagination-buttons">
//                   <button 
//                     onClick={goToPreviousPage} 
//                     disabled={currentPage === 1}
//                     className="pagination-btn prev"
//                   >
//                     &laquo; Previous
//                   </button>
                  
//                   {/* Page Numbers */}
//                   <div className="page-numbers">
//                     {[...Array(totalPages)].map((_, index) => {
//                       const pageNumber = index + 1;
//                       if (
//                         pageNumber === 1 ||
//                         pageNumber === totalPages ||
//                         (pageNumber >= currentPage - 2 && pageNumber <= currentPage + 2)
//                       ) {
//                         return (
//                           <button
//                             key={pageNumber}
//                             onClick={() => paginate(pageNumber)}
//                             className={`page-number ${currentPage === pageNumber ? 'active' : ''}`}
//                           >
//                             {pageNumber}
//                           </button>
//                         );
//                       } else if (
//                         pageNumber === currentPage - 3 ||
//                         pageNumber === currentPage + 3
//                       ) {
//                         return <span key={pageNumber} className="page-ellipsis">...</span>;
//                       }
//                       return null;
//                     })}
//                   </div>
                  
//                   <button 
//                     onClick={goToNextPage} 
//                     disabled={currentPage === totalPages}
//                     className="pagination-btn next"
//                   >
//                     Next &raquo;
//                   </button>
//                 </div>
//               </div>
//             </div>
//           </>
//         ) : (
//           <div className="empty-state">
//             <div className="empty-icon">💼</div>
//             <h3>No jobs found</h3>
//             <p>Try posting a new job or adjust your search filters</p>
//             <button onClick={() => setShowModal(true)} className="btn-primary">
//               Post Your First Job
//             </button>
//           </div>
//         )}
//       </div>

//       {/* Add/Edit Modal */}
//       {showModal && (
//         <div className="modal-overlay">
//           <div className="modal-content">
//             <div className="modal-header">
//               <h2>{editingJob ? 'Edit Job' : 'Post New Job'}</h2>
//               <button onClick={() => { resetForm(); setShowModal(false); }} className="modal-close">
//                 ×
//               </button>
//             </div>
            
//             <form onSubmit={handleSubmit}>
//               <div className="modal-body">
//                 <div className="form-grid">
//                   <div className="form-group">
//                     <label>Job Title *</label>
//                     <input
//                       type="text"
//                       name="title"
//                       value={formData.title}
//                       onChange={handleInputChange}
//                       placeholder="e.g., Senior React Developer"
//                       required
//                       className="form-input"
//                     />
//                   </div>
                  
//                   <div className="form-group">
//                     <label>Company *</label>
//                     <select
//                       name="companyId"
//                       value={formData.companyId}
//                       onChange={handleInputChange}
//                       required
//                       className="form-select"
//                     >
//                       <option value="">Select Company</option>
//                       {companyOptions.map(company => (
//                         <option key={company.id} value={company.id}>{company.name}</option>
//                       ))}
//                     </select>
//                   </div>
                  
//                   <div className="form-group">
//                     <label>Location</label>
//                     <input
//                       type="text"
//                       name="location"
//                       value={formData.location}
//                       onChange={handleInputChange}
//                       placeholder="e.g., Remote, Mumbai, Bangalore"
//                       className="form-input"
//                     />
//                   </div>
                  
//                   <div className="form-group">
//                     <label>Job Type</label>
//                     <select
//                       name="jobType"
//                       value={formData.jobType}
//                       onChange={handleInputChange}
//                       className="form-select"
//                     >
//                       <option value="Full-time">Full-time</option>
//                       <option value="Part-time">Part-time</option>
//                       <option value="Contract">Contract</option>
//                       <option value="Internship">Internship</option>
//                     </select>
//                   </div>
                  
//                   <div className="form-group">
//                     <label>Experience *</label>
//                     <input
//                       type="text"
//                       name="experience"
//                       value={formData.experience}
//                       onChange={handleInputChange}
//                       placeholder="e.g., 3-5 years, Fresher"
//                       required
//                       className="form-input"
//                     />
//                   </div>
                  
//                   <div className="form-group">
//                     <label>Salary *</label>
//                     <input
//                       type="text"
//                       name="salary"
//                       value={formData.salary}
//                       onChange={handleInputChange}
//                       placeholder="e.g., ₹10-15 LPA, Negotiable"
//                       required
//                       className="form-input"
//                     />
//                   </div>
                  
//                   <div className="form-group">
//                     <label>Status</label>
//                     <select
//                       name="status"
//                       value={formData.status}
//                       onChange={handleInputChange}
//                       className="form-select"
//                     >
//                       {Object.values(JOB_STATUS).map(status => (
//                         <option key={status} value={status}>{status}</option>
//                       ))}
//                     </select>
//                   </div>
//                 </div>
                
//                 <div className="form-group">
//                   <label>Key Skills/Requirements *</label>
//                   <textarea
//                     name="requirements"
//                     value={formData.requirements}
//                     onChange={handleInputChange}
//                     rows="3"
//                     placeholder="List key skills separated by commas (React, JavaScript, Node.js)"
//                     required
//                     className="form-textarea"
//                   />
//                 </div>
                
//                 <div className="form-group">
//                   <label>Additional Skills</label>
//                   <input
//                     type="text"
//                     name="skills"
//                     value={formData.skills}
//                     onChange={handleInputChange}
//                     placeholder="Other relevant skills"
//                     className="form-input"
//                   />
//                 </div>
                
//                 <div className="form-group">
//                   <label>Job Description *</label>
//                   <textarea
//                     name="description"
//                     value={formData.description}
//                     onChange={handleInputChange}
//                     rows="4"
//                     placeholder="Detailed job description, responsibilities, and requirements..."
//                     required
//                     className="form-textarea"
//                   />
//                 </div>
//               </div>
              
//               <div className="modal-footer">
//                 <button type="submit" className="btn-primary">
//                   {editingJob ? 'Update Job' : 'Post Job'}
//                 </button>
//                 <button 
//                   type="button" 
//                   onClick={() => { resetForm(); setShowModal(false); }}
//                   className="btn-secondary"
//                 >
//                   Cancel
//                 </button>
//               </div>
//             </form>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default Jobs;










// import React, { useState, useEffect } from 'react';
// import { getJobs, getCompanies, createJob, updateJob, deleteJob } from "../../services/api";
// import { JOB_STATUS } from '../../constants/statusConstants';
// import { useAuth } from "../../contexts/AuthContext";
// import './Jobs.css';

// const Jobs = () => {
//   // Get current user from AuthContext
//   const { currentUser } = useAuth();
  
//   const [jobs, setJobs] = useState([]);
//   const [companies, setCompanies] = useState({});
//   const [loading, setLoading] = useState(true);
//   const [showModal, setShowModal] = useState(false);
//   const [editingJob, setEditingJob] = useState(null);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [filterStatus, setFilterStatus] = useState('all');
//   const [filterCompany, setFilterCompany] = useState('all');
  
//   // View Modal States
//   const [viewingJob, setViewingJob] = useState(null);
//   const [showViewModal, setShowViewModal] = useState(false);
  
//   // Pagination states
//   const [currentPage, setCurrentPage] = useState(1);
//   const [itemsPerPage, setItemsPerPage] = useState(10);
//   const [itemsPerPageOptions] = useState([5, 10, 25, 50, 100]);

//   // Check if user is admin
//   const isAdmin = currentUser && currentUser.role === "admin";
  
//   const [formData, setFormData] = useState({
//     title: '',
//     companyId: '',
//     description: '',
//     requirements: '',
//     experience: '',
//     salary: '',
//     status: 'Open',
//     location: '',
//     jobType: 'Full-time',
//     skills: ''
//   });

//   useEffect(() => {
//     loadData();
//   }, []);

//   // Reset to first page when filters change
//   useEffect(() => {
//     setCurrentPage(1);
//   }, [searchTerm, filterStatus, filterCompany]);

//   const loadData = async () => {
//     try {
//       const jobsRes = await getJobs();
//       const companiesRes = await getCompanies();

//       const companiesMap = {};
//       companiesRes.data.forEach(company => {
//         companiesMap[company.id] = company;
//       });

//       setJobs(jobsRes.data);
//       setCompanies(companiesMap);
//     } catch (error) {
//       console.error(error);
//     }
//     setLoading(false);
//   };

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setFormData(prev => ({ ...prev, [name]: value }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     try {
//       if (editingJob) {
//         await updateJob(editingJob.id, formData);
//       } else {
//         await createJob(formData);
//       }
//       resetForm();
//       loadData();
//       setShowModal(false);
//     } catch (error) {
//       console.error("Error saving job:", error);
//     }
//   };

//   const handleView = (job) => {
//     setViewingJob(job);
//     setShowViewModal(true);
//   };

//   const handleEdit = (job) => {
//     // Only admin can edit
//     if (!isAdmin) {
//       alert("You don't have permission to edit jobs");
//       return;
//     }
//     setEditingJob(job);
//     setFormData(job);
//     setShowModal(true);
//   };

//   const handleDelete = async (id) => {
//     // Only admin can delete
//     if (!isAdmin) {
//       alert("You don't have permission to delete jobs");
//       return;
//     }
//     if (window.confirm('Are you sure? This will delete all related applications.')) {
//       await deleteJob(id);
//       loadData();
//     }
//   };

//   const resetForm = () => {
//     setFormData({
//       title: '',
//       companyId: '',
//       description: '',
//       requirements: '',
//       experience: '',
//       salary: '',
//       status: 'Open',
//       location: '',
//       jobType: 'Full-time',
//       skills: ''
//     });
//     setEditingJob(null);
//   };

//   // Filter jobs
//   // const filteredJobs = jobs.filter(job => {
//   //   const matchesSearch = 
//   //     job.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
//   //     job.requirements.toLowerCase().includes(searchTerm.toLowerCase()) ||
//   //     job.description.toLowerCase().includes(searchTerm.toLowerCase());
    
//   //   const matchesStatus = filterStatus === 'all' || job.status === filterStatus;
//   //   const matchesCompany = filterCompany === 'all' || job.companyId === filterCompany;
    
//   //   return matchesSearch && matchesStatus && matchesCompany;
//   // });



//   const filteredJobs = jobs.filter(job => {
//   const matchesSearch =
//     job.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
//     job.requirements.toLowerCase().includes(searchTerm.toLowerCase()) ||
//     job.description.toLowerCase().includes(searchTerm.toLowerCase());

//   const matchesStatus = filterStatus === 'all' || job.status === filterStatus;

//   const matchesCompany =
//     filterCompany === 'all' ||
//     String(job.companyId) === String(filterCompany);

//   return matchesSearch && matchesStatus && matchesCompany;
// });

//   // Pagination logic
//   const indexOfLastItem = currentPage * itemsPerPage;
//   const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//   const currentItems = filteredJobs.slice(indexOfFirstItem, indexOfLastItem);
//   const totalPages = Math.ceil(filteredJobs.length / itemsPerPage);

//   // Pagination handlers
//   const paginate = (pageNumber) => setCurrentPage(pageNumber);
  
//   const goToPreviousPage = () => {
//     if (currentPage > 1) {
//       setCurrentPage(currentPage - 1);
//     }
//   };
  
//   const goToNextPage = () => {
//     if (currentPage < totalPages) {
//       setCurrentPage(currentPage + 1);
//     }
//   };
  
//   const handleItemsPerPageChange = (e) => {
//     setItemsPerPage(Number(e.target.value));
//     setCurrentPage(1);
//   };

//   const companyOptions = Object.values(companies);
//   const openJobs = jobs.filter(job => job.status === 'Open').length;

//   if (loading) {
//     return (
//       <div className="loading-container">
//         <div className="spinner"></div>
//         <p>Loading jobs...</p>
//       </div>
//     );
//   }

//   return (
//     <div className="jobs-page">
//       {/* Page Header */}
//       <div className="page-header">
//         <div className='comp'>
//           <h1>Job Requirements</h1>
//           <p>Manage job openings and requirements</p>
//           {!isAdmin && (
//             <small style={{ color: '#666', fontSize: '12px' }}>View Only Mode</small>
//           )}
//         </div>
//         {isAdmin && (
//           <button onClick={() => setShowModal(true)} className="btn-primary">
//             <span className="btn-icon">+</span> Post New Job
//           </button>
//         )}
//       </div>

//       {/* Stats */}
//       <div className="stats-cards">
//         <div className="stat-card">
//           <div className="stat-icon">💼</div>
//           <div className="stat-content">
//             <h3>{jobs.length}</h3>
//             <p>Total Jobs</p>
//           </div>
//         </div>
//         <div className="stat-card">
//           <div className="stat-icon">✅</div>
//           <div className="stat-content">
//             <h3>{openJobs}</h3>
//             <p>Open Positions</p>
//           </div>
//         </div>
//         <div className="stat-card">
//           <div className="stat-icon">🏢</div>
//           <div className="stat-content">
//             <h3>{companyOptions.length}</h3>
//             <p>Companies</p>
//           </div>
//         </div>
//       </div>

//       {/* Filters */}
//       <div className="filters-section">
//         <div className="search-box">
//           <input
//             type="text"
//             placeholder="Search jobs by title, requirements, or description..."
//             value={searchTerm}
//             onChange={(e) => setSearchTerm(e.target.value)}
//             className="search-input"
//           />
//           <span className="search-icon">🔍</span>
//         </div>
        
//         <div className="filter-controls">
//           <select 
//             value={filterStatus} 
//             onChange={(e) => setFilterStatus(e.target.value)}
//             className="filter-select"
//           >
//             <option value="all">All Status</option>
//             {Object.values(JOB_STATUS).map(status => (
//               <option key={status} value={status}>{status}</option>
//             ))}
//           </select>
          
//           <select 
//             value={filterCompany} 
//             onChange={(e) => setFilterCompany(e.target.value)}
//             className="filter-select"
//           >
//             <option value="all">All Companies</option>
//             {companyOptions.map(company => (
//               <option key={company.id} value={company.id}>{company.name}</option>
//             ))}
//           </select>
//         </div>
//       </div>

//       {/* Jobs Table with Pagination */}
//       <div className="table-container">
//         {filteredJobs.length > 0 ? (
//           <>
//             <table className="data-table">
//               <thead>
//                 <tr>
//                   <th>Job Title</th>
//                   <th>Company</th>
//                   <th>Requirements</th>
//                   <th>Experience</th>
//                   <th>Salary</th>
//                   <th>Status</th>
//                   <th>Actions</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {currentItems.map(job => (
//                   <tr key={job.id}>
//                     <td>
//                       <div className="job-title-cell">
//                         <div className="job-icon">💼</div>
//                         <div>
//                           <div className="job-title">
//                             {job.title}
//                           </div>
//                           <div className="job-meta">
//                             <span className="job-location">{job.location || 'Remote'}</span>
//                             <span className="job-type">{job.jobType}</span>
//                           </div>
//                         </div>
//                       </div>
//                     </td>
//                     <td>
//                       <div className="company-link">
//                         {companies[job.companyId]?.name || 'Unknown'}
//                       </div>
//                     </td>
//                     <td>
//                       <div className="requirements-cell">
//                         {job.requirements?.split(',').slice(0, 2).map((req, idx) => (
//                           <span key={idx} className="requirement-tag">{req.trim()}</span>
//                         ))}
//                         {job.requirements?.split(',').length > 2 && (
//                           <span className="more-tag">+{job.requirements.split(',').length - 2} more</span>
//                         )}
//                       </div>
//                     </td>
//                     <td>{job.experience || 'Not specified'}</td>
//                     <td className="salary-cell">{job.salary || 'Negotiable'}</td>
//                     <td>
//                       <span className={`status-badge ${job.status === 'Open' ? 'open' : job.status === 'Closed' ? 'closed' : 'hold'}`}>
//                         {job.status}
//                       </span>
//                     </td>
//                     <td>
//                       <div className="action-buttons">
//                         {/* View Button - Opens Modal */}
//                         <button 
//                           onClick={() => handleView(job)} 
//                           className="action-btn view"
//                           title="View Job Details"
//                         >
//                           👁️
//                         </button>
                        
//                         {/* Edit Button - Only visible to admin */}
//                         {isAdmin && (
//                           <button 
//                             onClick={() => handleEdit(job)} 
//                             className="action-btn edit"
//                             title="Edit"
//                           >
//                             ✏️
//                           </button>
//                         )}
                        
//                         {/* Delete Button - Only visible to admin */}
//                         {isAdmin && (
//                           <button 
//                             onClick={() => handleDelete(job.id)} 
//                             className="action-btn delete"
//                             title="Delete"
//                           >
//                             🗑️
//                           </button>
//                         )}
//                       </div>
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>

//             {/* Pagination Controls */}
//             <div className="pagination-container">
//               <div className="pagination-info">
//                 Showing {indexOfFirstItem + 1} to {Math.min(indexOfLastItem, filteredJobs.length)} of {filteredJobs.length} entries
//               </div>
              
//               <div className="pagination-controls">
//                 <div className="items-per-page">
//                   <label>Show:</label>
//                   <select 
//                     value={itemsPerPage} 
//                     onChange={handleItemsPerPageChange}
//                     className="items-per-page-select"
//                   >
//                     {itemsPerPageOptions.map(option => (
//                       <option key={option} value={option}>{option}</option>
//                     ))}
//                   </select>
//                 </div>
                
//                 <div className="pagination-buttons">
//                   <button 
//                     onClick={goToPreviousPage} 
//                     disabled={currentPage === 1}
//                     className="pagination-btn prev"
//                   >
//                     &laquo; Previous
//                   </button>
                  
//                   {/* Page Numbers */}
//                   <div className="page-numbers">
//                     {[...Array(totalPages)].map((_, index) => {
//                       const pageNumber = index + 1;
//                       if (
//                         pageNumber === 1 ||
//                         pageNumber === totalPages ||
//                         (pageNumber >= currentPage - 2 && pageNumber <= currentPage + 2)
//                       ) {
//                         return (
//                           <button
//                             key={pageNumber}
//                             onClick={() => paginate(pageNumber)}
//                             className={`page-number ${currentPage === pageNumber ? 'active' : ''}`}
//                           >
//                             {pageNumber}
//                           </button>
//                         );
//                       } else if (
//                         pageNumber === currentPage - 3 ||
//                         pageNumber === currentPage + 3
//                       ) {
//                         return <span key={pageNumber} className="page-ellipsis">...</span>;
//                       }
//                       return null;
//                     })}
//                   </div>
                  
//                   <button 
//                     onClick={goToNextPage} 
//                     disabled={currentPage === totalPages}
//                     className="pagination-btn next"
//                   >
//                     Next &raquo;
//                   </button>
//                 </div>
//               </div>
//             </div>
//           </>
//         ) : (
//           <div className="empty-state">
//             <div className="empty-icon">💼</div>
//             <h3>No jobs found</h3>
//             <p>Try posting a new job or adjust your search filters</p>
//             {isAdmin && (
//               <button onClick={() => setShowModal(true)} className="btn-primary">
//                 Post Your First Job
//               </button>
//             )}
//           </div>
//         )}
//       </div>

//       {/* Add/Edit Modal */}
//       {showModal && (
//         <div className="modal-overlay">
//           <div className="modal-content">
//             <div className="modal-header">
//               <h2>{editingJob ? 'Edit Job' : 'Post New Job'}</h2>
//               <button onClick={() => { resetForm(); setShowModal(false); }} className="modal-close">
//                 ×
//               </button>
//             </div>
            
//             <form onSubmit={handleSubmit}>
//               <div className="modal-body">
//                 <div className="form-grid">
//                   <div className="form-group">
//                     <label>Job Title *</label>
//                     <input
//                       type="text"
//                       name="title"
//                       value={formData.title}
//                       onChange={handleInputChange}
//                       placeholder="e.g., Senior React Developer"
//                       required
//                       className="form-input"
//                     />
//                   </div>
                  
//                   <div className="form-group">
//                     <label>Company *</label>
//                     <select
//                       name="companyId"
//                       value={formData.companyId}
//                       onChange={handleInputChange}
//                       required
//                       className="form-select"
//                     >
//                       <option value="">Select Company</option>
//                       {companyOptions.map(company => (
//                         <option key={company.id} value={company.id}>{company.name}</option>
//                       ))}
//                     </select>
//                   </div>
                  
//                   <div className="form-group">
//                     <label>Location</label>
//                     <input
//                       type="text"
//                       name="location"
//                       value={formData.location}
//                       onChange={handleInputChange}
//                       placeholder="e.g., Remote, Mumbai, Bangalore"
//                       className="form-input"
//                     />
//                   </div>
                  
//                   <div className="form-group">
//                     <label>Job Type</label>
//                     <select
//                       name="jobType"
//                       value={formData.jobType}
//                       onChange={handleInputChange}
//                       className="form-select"
//                     >
//                       <option value="Full-time">Full-time</option>
//                       <option value="Part-time">Part-time</option>
//                       <option value="Contract">Contract</option>
//                       <option value="Internship">Internship</option>
//                     </select>
//                   </div>
                  
//                   <div className="form-group">
//                     <label>Experience *</label>
//                     <input
//                       type="text"
//                       name="experience"
//                       value={formData.experience}
//                       onChange={handleInputChange}
//                       placeholder="e.g., 3-5 years, Fresher"
//                       required
//                       className="form-input"
//                     />
//                   </div>
                  
//                   <div className="form-group">
//                     <label>Salary *</label>
//                     <input
//                       type="text"
//                       name="salary"
//                       value={formData.salary}
//                       onChange={handleInputChange}
//                       placeholder="e.g., ₹10-15 LPA, Negotiable"
//                       required
//                       className="form-input"
//                     />
//                   </div>
                  
//                   <div className="form-group">
//                     <label>Status</label>
//                     <select
//                       name="status"
//                       value={formData.status}
//                       onChange={handleInputChange}
//                       className="form-select"
//                     >
//                       {Object.values(JOB_STATUS).map(status => (
//                         <option key={status} value={status}>{status}</option>
//                       ))}
//                     </select>
//                   </div>
//                 </div>
                
//                 <div className="form-group">
//                   <label>Key Skills/Requirements *</label>
//                   <textarea
//                     name="requirements"
//                     value={formData.requirements}
//                     onChange={handleInputChange}
//                     rows="3"
//                     placeholder="List key skills separated by commas (React, JavaScript, Node.js)"
//                     required
//                     className="form-textarea"
//                   />
//                 </div>
                
//                 <div className="form-group">
//                   <label>Additional Skills</label>
//                   <input
//                     type="text"
//                     name="skills"
//                     value={formData.skills}
//                     onChange={handleInputChange}
//                     placeholder="Other relevant skills"
//                     className="form-input"
//                   />
//                 </div>
                
//                 <div className="form-group">
//                   <label>Job Description *</label>
//                   <textarea
//                     name="description"
//                     value={formData.description}
//                     onChange={handleInputChange}
//                     rows="4"
//                     placeholder="Detailed job description, responsibilities, and requirements..."
//                     required
//                     className="form-textarea"
//                   />
//                 </div>
//               </div>
              
//               <div className="modal-footer">
//                 <button type="submit" className="btn-primary">
//                   {editingJob ? 'Update Job' : 'Post Job'}
//                 </button>
//                 <button 
//                   type="button" 
//                   onClick={() => { resetForm(); setShowModal(false); }}
//                   className="btn-secondary"
//                 >
//                   Cancel
//                 </button>
//               </div>
//             </form>
//           </div>
//         </div>
//       )}

//       {/* View Job Modal - Similar to Candidate Modal */}
//       {showViewModal && viewingJob && (
//         <div className="modal-overlay">
//           <div className="modal-content modal-lg">
//             <div className="modal-header">
//               <h2>Job Details</h2>
//               <button
//                 className="modal-close"
//                 onClick={() => {
//                   setViewingJob(null);
//                   setShowViewModal(false);
//                 }}
//               >
//                 ×
//               </button>
//             </div>

//             <div className="modal-body">
//               <div className="view-job-header">
//                 <div className="view-job-icon">💼</div>
//                 <div className="view-job-title">
//                   <h3>{viewingJob.title}</h3>
//                   <p>{companies[viewingJob.companyId]?.name || 'Unknown Company'}</p>
//                 </div>
//                 <div className="view-job-badges">
//                   <span className={`status-badge ${viewingJob.status === 'Open' ? 'open' : viewingJob.status === 'Closed' ? 'closed' : 'hold'}`}>
//                     {viewingJob.status}
//                   </span>
//                 </div>
//               </div>

//               <div className="view-details-grid">
//                 <div className="view-details-section">
//                   <h4>Job Information</h4>
//                   <div className="view-details-row">
//                     <span className="detail-label">Location:</span>
//                     <span className="detail-value">{viewingJob.location || 'Remote'}</span>
//                   </div>
//                   <div className="view-details-row">
//                     <span className="detail-label">Job Type:</span>
//                     <span className="detail-value">{viewingJob.jobType || 'Full-time'}</span>
//                   </div>
//                   <div className="view-details-row">
//                     <span className="detail-label">Experience:</span>
//                     <span className="detail-value">{viewingJob.experience || 'Not specified'}</span>
//                   </div>
//                   <div className="view-details-row">
//                     <span className="detail-label">Salary:</span>
//                     <span className="detail-value">{viewingJob.salary || 'Negotiable'}</span>
//                   </div>
//                 </div>

//                 <div className="view-details-section">
//                   <h4>Key Requirements</h4>
//                   <div className="skills-container">
//                     {(viewingJob.requirements || '')
//                       .split(',')
//                       .map(s => s.trim())
//                       .filter(Boolean)
//                       .map((req, index) => (
//                         <span key={index} className="skill-tag large">
//                           {req}
//                         </span>
//                       ))}
//                     {!viewingJob.requirements && <span className="detail-value">No requirements specified</span>}
//                   </div>
//                 </div>

//                 <div className="view-details-section full-width">
//                   <h4>Job Description</h4>
//                   <div className="detail-value" style={{ whiteSpace: 'pre-wrap', lineHeight: '1.6' }}>
//                     {viewingJob.description || 'No description provided'}
//                   </div>
//                 </div>

//                 {viewingJob.skills && (
//                   <div className="view-details-section full-width">
//                     <h4>Additional Skills</h4>
//                     <div className="skills-container">
//                       {(viewingJob.skills || '')
//                         .split(',')
//                         .map(s => s.trim())
//                         .filter(Boolean)
//                         .map((skill, index) => (
//                           <span key={index} className="skill-tag">
//                             {skill}
//                           </span>
//                         ))}
//                     </div>
//                   </div>
//                 )}
//               </div>
//             </div>

//             <div className="modal-footer">
//               <button
//                 type="button"
//                 className="btn-secondary"
//                 onClick={() => {
//                   setViewingJob(null);
//                   setShowViewModal(false);
//                 }}
//               >
//                 Close
//               </button>
//               {isAdmin && (
//                 <button
//                   type="button"
//                   className="btn-primary"
//                   onClick={() => {
//                     setViewingJob(null);
//                     setShowViewModal(false);
//                     handleEdit(viewingJob);
//                   }}
//                 >
//                   Edit Job
//                 </button>
//               )}
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default Jobs;




















import React, { useState, useEffect } from 'react';
import { getJobs, getCompanies, createJob, updateJob, deleteJob } from "../../services/api";
import { JOB_STATUS } from '../../constants/statusConstants';
import { useAuth } from "../../contexts/AuthContext";
import './Jobs.css';

const Jobs = () => {
  // Get current user from AuthContext
  const { currentUser } = useAuth();
  
  const [jobs, setJobs] = useState([]);
  const [companies, setCompanies] = useState({});
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [editingJob, setEditingJob] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [filterStatus, setFilterStatus] = useState('all');
  const [filterCompany, setFilterCompany] = useState('all');
  
  // View Modal States
  const [viewingJob, setViewingJob] = useState(null);
  const [showViewModal, setShowViewModal] = useState(false);
  
  // Pagination states
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [itemsPerPageOptions] = useState([5, 10, 25, 50, 100]);

  // Check if user is admin
  const isAdmin = currentUser && currentUser.role === "admin";
  
  const [formData, setFormData] = useState({
    title: '',
    companyId: '',
    description: '',
    requirements: '',
    experience: '',
    salary: '',
    status: 'Open',
    location: '',
    jobType: 'Full-time',
    skills: ''
  });

  useEffect(() => {
    loadData();
  }, []);

  // Reset to first page when filters change
  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm, filterStatus, filterCompany]);

  const loadData = async () => {
    try {
      const jobsRes = await getJobs();
      const companiesRes = await getCompanies();

      const companiesMap = {};
      companiesRes.data.forEach(company => {
        companiesMap[company.id] = company;
      });

      setJobs(jobsRes.data);
      setCompanies(companiesMap);
    } catch (error) {
      console.error(error);
    }
    setLoading(false);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editingJob) {
        await updateJob(editingJob.id, formData);
      } else {
        await createJob(formData);
      }
      resetForm();
      loadData();
      setShowModal(false);
    } catch (error) {
      console.error("Error saving job:", error);
    }
  };

  const handleView = (job) => {
    setViewingJob(job);
    setShowViewModal(true);
  };

  const handleEdit = (job) => {
    // Only admin can edit
    if (!isAdmin) {
      alert("You don't have permission to edit jobs");
      return;
    }
    setEditingJob(job);
    setFormData(job);
    setShowModal(true);
  };

  const handleDelete = async (id) => {
    // Only admin can delete
    if (!isAdmin) {
      alert("You don't have permission to delete jobs");
      return;
    }
    if (window.confirm('Are you sure you want to delete this job?')) {
      await deleteJob(id);
      loadData();
    }
  };

  const resetForm = () => {
    setFormData({
      title: '',
      companyId: '',
      description: '',
      requirements: '',
      experience: '',
      salary: '',
      status: 'Open',
      location: '',
      jobType: 'Full-time',
      skills: ''
    });
    setEditingJob(null);
  };

  // Filter jobs - UPDATED with proper status filtering
  const filteredJobs = jobs.filter(job => {
    const search = searchTerm.toLowerCase();
    const title = job.title?.toLowerCase() || "";
    const requirements = job.requirements?.toLowerCase() || "";
    const description = job.description?.toLowerCase() || "";
    const skills = job.skills?.toLowerCase() || "";
    
    const matchesSearch = !searchTerm || 
      title.includes(search) ||
      requirements.includes(search) ||
      description.includes(search) ||
      skills.includes(search);
    
    const matchesStatus = filterStatus === 'all' || job.status === filterStatus;
    
    const matchesCompany = filterCompany === 'all' || 
      String(job.companyId) === String(filterCompany);
    
    return matchesSearch && matchesStatus && matchesCompany;
  });

  // Pagination logic
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredJobs.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredJobs.length / itemsPerPage);

  // Pagination handlers
  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  
  const goToPreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };
  
  const goToNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };
  
  const handleItemsPerPageChange = (e) => {
    setItemsPerPage(Number(e.target.value));
    setCurrentPage(1);
  };

  const companyOptions = Object.values(companies);
  const openJobs = jobs.filter(job => job.status === 'Open').length;

  if (loading) {
    return (
      <div className="loading-container">
        <div className="spinner"></div>
        <p>Loading jobs...</p>
      </div>
    );
  }

  return (
    <div className="jobs-page">
      {/* Page Header */}
      <div className="page-header">
        <div className='comp'>
          <h1>Job Requirements</h1>
          <p>Manage job openings and requirements</p>
          {!isAdmin && (
            <small style={{ color: '#666', fontSize: '12px' }}>View Only Mode</small>
          )}
        </div>
        {isAdmin && (
          <button onClick={() => setShowModal(true)} className="btn-primary">
            <span className="btn-icon">+</span> Post New Job
          </button>
        )}
      </div>

      {/* Stats */}
      <div className="stats-cards">
        <div className="stat-card">
          <div className="stat-icon">💼</div>
          <div className="stat-content">
            <h3>{jobs.length}</h3>
            <p>Total Jobs</p>
          </div>
        </div>
        <div className="stat-card">
          <div className="stat-icon">✅</div>
          <div className="stat-content">
            <h3>{openJobs}</h3>
            <p>Open Positions</p>
          </div>
        </div>
        <div className="stat-card">
          <div className="stat-icon">🏢</div>
          <div className="stat-content">
            <h3>{companyOptions.length}</h3>
            <p>Companies</p>
          </div>
        </div>
      </div>

      {/* Filters */}
      <div className="filters-section">
        <div className="search-box">
          <input
            type="text"
            placeholder="Search jobs by title, requirements, description, or skills..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="search-input"
          />
          <span className="search-icon">🔍</span>
        </div>
        
        <div className="filter-controls">
          <select 
            value={filterStatus} 
            onChange={(e) => setFilterStatus(e.target.value)}
            className="filter-select"
          >
            <option value="all">All Status</option>
            {Object.values(JOB_STATUS).map(status => (
              <option key={status} value={status}>{status}</option>
            ))}
          </select>
          
          <select 
            value={filterCompany} 
            onChange={(e) => setFilterCompany(e.target.value)}
            className="filter-select"
          >
            <option value="all">All Companies</option>
            {companyOptions.map(company => (
              <option key={company.id} value={company.id}>{company.name}</option>
            ))}
          </select>
        </div>
      </div>

      {/* Jobs Table with Pagination */}
      <div className="table-container">
        {filteredJobs.length > 0 ? (
          <>
            <table className="data-table">
              <thead>
                <tr>
                  <th>Job Title</th>
                  <th>Company</th>
                  <th>Requirements</th>
                  <th>Experience</th>
                  <th>Salary</th>
                  <th>Status</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {currentItems.map(job => (
                  <tr key={job.id}>
                    <td>
                      <div className="job-title-cell">
                        <div className="job-icon">💼</div>
                        <div>
                          <div className="job-title">
                            {job.title}
                          </div>
                          <div className="job-meta">
                            <span className="job-location">{job.location || 'Remote'}</span>
                            <span className="job-type">{job.jobType}</span>
                          </div>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div className="company-link">
                        {companies[job.companyId]?.name || 'Unknown'}
                      </div>
                    </td>
                    <td>
                      <div className="requirements-cell">
                        {(job.requirements || '')
                          .split(',')
                          .slice(0, 2)
                          .map((req, idx) => (
                            <span key={idx} className="requirement-tag">{req.trim()}</span>
                          ))}
                        {(job.requirements || '').split(',').filter(Boolean).length > 2 && (
                          <span className="more-tag">
                            +{(job.requirements || '').split(',').filter(Boolean).length - 2} more
                          </span>
                        )}
                      </div>
                    </td>
                    <td>{job.experience || 'Not specified'}</td>
                    <td className="salary-cell">{job.salary || 'Negotiable'}</td>
                    <td>
                      <span className={`status-badge ${job.status === 'Open' ? 'open' : job.status === 'Closed' ? 'closed' : 'hold'}`}>
                        {job.status}
                      </span>
                    </td>
                    <td>
                      <div className="action-buttons">
                        {/* View Button - Opens Modal */}
                        <button 
                          onClick={() => handleView(job)} 
                          className="action-btn view"
                          title="View Job Details"
                        >
                          👁️
                        </button>
                        
                        {/* Edit Button - Only visible to admin */}
                        {isAdmin && (
                          <button 
                            onClick={() => handleEdit(job)} 
                            className="action-btn edit"
                            title="Edit"
                          >
                            ✏️
                          </button>
                        )}
                        
                        {/* Delete Button - Only visible to admin */}
                        {isAdmin && (
                          <button 
                            onClick={() => handleDelete(job.id)} 
                            className="action-btn delete"
                            title="Delete"
                          >
                            🗑️
                          </button>
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            {/* Pagination Controls */}
            <div className="pagination-container">
              <div className="pagination-info">
                Showing {indexOfFirstItem + 1} to {Math.min(indexOfLastItem, filteredJobs.length)} of {filteredJobs.length} entries
              </div>
              
              <div className="pagination-controls">
                <div className="items-per-page">
                  <label>Show:</label>
                  <select 
                    value={itemsPerPage} 
                    onChange={handleItemsPerPageChange}
                    className="items-per-page-select"
                  >
                    {itemsPerPageOptions.map(option => (
                      <option key={option} value={option}>{option}</option>
                    ))}
                  </select>
                </div>
                
                <div className="pagination-buttons">
                  <button 
                    onClick={goToPreviousPage} 
                    disabled={currentPage === 1}
                    className="pagination-btn prev"
                  >
                    &laquo; Previous
                  </button>
                  
                  {/* Page Numbers */}
                  <div className="page-numbers">
                    {[...Array(totalPages)].map((_, index) => {
                      const pageNumber = index + 1;
                      if (
                        pageNumber === 1 ||
                        pageNumber === totalPages ||
                        (pageNumber >= currentPage - 2 && pageNumber <= currentPage + 2)
                      ) {
                        return (
                          <button
                            key={pageNumber}
                            onClick={() => paginate(pageNumber)}
                            className={`page-number ${currentPage === pageNumber ? 'active' : ''}`}
                          >
                            {pageNumber}
                          </button>
                        );
                      } else if (
                        pageNumber === currentPage - 3 ||
                        pageNumber === currentPage + 3
                      ) {
                        return <span key={pageNumber} className="page-ellipsis">...</span>;
                      }
                      return null;
                    })}
                  </div>
                  
                  <button 
                    onClick={goToNextPage} 
                    disabled={currentPage === totalPages}
                    className="pagination-btn next"
                  >
                    Next &raquo;
                  </button>
                </div>
              </div>
            </div>
          </>
        ) : (
          <div className="empty-state">
            <div className="empty-icon">💼</div>
            <h3>No jobs found</h3>
            <p>Try posting a new job or adjust your search filters</p>
            {isAdmin && (
              <button onClick={() => setShowModal(true)} className="btn-primary">
                Post Your First Job
              </button>
            )}
          </div>
        )}
      </div>

      {/* Add/Edit Modal */}
      {showModal && (
        <div className="modal-overlay">
          <div className="modal-content">
            <div className="modal-header">
              <h2>{editingJob ? 'Edit Job' : 'Post New Job'}</h2>
              <button onClick={() => { resetForm(); setShowModal(false); }} className="modal-close">
                ×
              </button>
            </div>
            
            <form onSubmit={handleSubmit}>
              <div className="modal-body">
                <div className="form-grid">
                  <div className="form-group">
                    <label>Job Title *</label>
                    <input
                      type="text"
                      name="title"
                      value={formData.title}
                      onChange={handleInputChange}
                      placeholder="e.g., Senior React Developer"
                      required
                      className="form-input"
                    />
                  </div>
                  
                  <div className="form-group">
                    <label>Company *</label>
                    <select
                      name="companyId"
                      value={formData.companyId}
                      onChange={handleInputChange}
                      required
                      className="form-select"
                    >
                      <option value="">Select Company</option>
                      {companyOptions.map(company => (
                        <option key={company.id} value={company.id}>{company.name}</option>
                      ))}
                    </select>
                  </div>
                  
                  <div className="form-group">
                    <label>Location</label>
                    <input
                      type="text"
                      name="location"
                      value={formData.location}
                      onChange={handleInputChange}
                      placeholder="e.g., Remote, Mumbai, Bangalore"
                      className="form-input"
                    />
                  </div>
                  
                  <div className="form-group">
                    <label>Job Type</label>
                    <select
                      name="jobType"
                      value={formData.jobType}
                      onChange={handleInputChange}
                      className="form-select"
                    >
                      <option value="Full-time">Full-time</option>
                      <option value="Part-time">Part-time</option>
                      <option value="Contract">Contract</option>
                      <option value="Internship">Internship</option>
                    </select>
                  </div>
                  
                  <div className="form-group">
                    <label>Experience *</label>
                    <input
                      type="text"
                      name="experience"
                      value={formData.experience}
                      onChange={handleInputChange}
                      placeholder="e.g., 3-5 years, Fresher"
                      required
                      className="form-input"
                    />
                  </div>
                  
                  <div className="form-group">
                    <label>Salary *</label>
                    <input
                      type="text"
                      name="salary"
                      value={formData.salary}
                      onChange={handleInputChange}
                      placeholder="e.g., ₹10-15 LPA, Negotiable"
                      required
                      className="form-input"
                    />
                  </div>
                  
                  <div className="form-group">
                    <label>Status</label>
                    <select
                      name="status"
                      value={formData.status}
                      onChange={handleInputChange}
                      className="form-select"
                    >
                      {Object.values(JOB_STATUS).map(status => (
                        <option key={status} value={status}>{status}</option>
                      ))}
                    </select>
                  </div>
                </div>
                
                <div className="form-group">
                  <label>Key Skills/Requirements *</label>
                  <textarea
                    name="requirements"
                    value={formData.requirements}
                    onChange={handleInputChange}
                    rows="3"
                    placeholder="List key skills separated by commas (React, JavaScript, Node.js)"
                    required
                    className="form-textarea"
                  />
                </div>
                
                <div className="form-group">
                  <label>Additional Skills</label>
                  <input
                    type="text"
                    name="skills"
                    value={formData.skills}
                    onChange={handleInputChange}
                    placeholder="Other relevant skills"
                    className="form-input"
                  />
                </div>
                
                <div className="form-group">
                  <label>Job Description *</label>
                  <textarea
                    name="description"
                    value={formData.description}
                    onChange={handleInputChange}
                    rows="4"
                    placeholder="Detailed job description, responsibilities, and requirements..."
                    required
                    className="form-textarea"
                  />
                </div>
              </div>
              
              <div className="modal-footer">
                <button type="submit" className="btn-primary">
                  {editingJob ? 'Update Job' : 'Post Job'}
                </button>
                <button 
                  type="button" 
                  onClick={() => { resetForm(); setShowModal(false); }}
                  className="btn-secondary"
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* View Job Modal - Similar to Candidate Modal */}
      {showViewModal && viewingJob && (
        <div className="modal-overlay">
          <div className="modal-content modal-lg">
            <div className="modal-header">
              <h2>Job Details</h2>
              <button
                className="modal-close"
                onClick={() => {
                  setViewingJob(null);
                  setShowViewModal(false);
                }}
              >
                ×
              </button>
            </div>

            <div className="modal-body">
              <div className="view-job-header">
                <div className="view-job-icon">💼</div>
                <div className="view-job-title">
                  <h3>{viewingJob.title}</h3>
                  <p>{companies[viewingJob.companyId]?.name || 'Unknown Company'}</p>
                </div>
                <div className="view-job-badges">
                  <span className={`status-badge ${viewingJob.status === 'Open' ? 'open' : viewingJob.status === 'Closed' ? 'closed' : 'hold'}`}>
                    {viewingJob.status}
                  </span>
                </div>
              </div>

              <div className="view-details-grid">
                <div className="view-details-section">
                  <h4>Job Information</h4>
                  <div className="view-details-row">
                    <span className="detail-label">Location:</span>
                    <span className="detail-value">{viewingJob.location || 'Remote'}</span>
                  </div>
                  <div className="view-details-row">
                    <span className="detail-label">Job Type:</span>
                    <span className="detail-value">{viewingJob.jobType || 'Full-time'}</span>
                  </div>
                  <div className="view-details-row">
                    <span className="detail-label">Experience:</span>
                    <span className="detail-value">{viewingJob.experience || 'Not specified'}</span>
                  </div>
                  <div className="view-details-row">
                    <span className="detail-label">Salary:</span>
                    <span className="detail-value">{viewingJob.salary || 'Negotiable'}</span>
                  </div>
                </div>

                <div className="view-details-section">
                  <h4>Key Requirements</h4>
                  <div className="skills-container">
                    {(viewingJob.requirements || '')
                      .split(',')
                      .map(s => s.trim())
                      .filter(Boolean)
                      .map((req, index) => (
                        <span key={index} className="skill-tag large">
                          {req}
                        </span>
                      ))}
                    {!viewingJob.requirements && <span className="detail-value">No requirements specified</span>}
                  </div>
                </div>

                <div className="view-details-section full-width">
                  <h4>Job Description</h4>
                  <div className="detail-value" style={{ whiteSpace: 'pre-wrap', lineHeight: '1.6' }}>
                    {viewingJob.description || 'No description provided'}
                  </div>
                </div>

                {viewingJob.skills && (
                  <div className="view-details-section full-width">
                    <h4>Additional Skills</h4>
                    <div className="skills-container">
                      {(viewingJob.skills || '')
                        .split(',')
                        .map(s => s.trim())
                        .filter(Boolean)
                        .map((skill, index) => (
                          <span key={index} className="skill-tag">
                            {skill}
                          </span>
                        ))}
                    </div>
                  </div>
                )}
              </div>
            </div>

            <div className="modal-footer">
              <button
                type="button"
                className="btn-secondary"
                onClick={() => {
                  setViewingJob(null);
                  setShowViewModal(false);
                }}
              >
                Close
              </button>
              {isAdmin && (
                <button
                  type="button"
                  className="btn-primary"
                  onClick={() => {
                    setViewingJob(null);
                    setShowViewModal(false);
                    handleEdit(viewingJob);
                  }}
                >
                  Edit Job
                </button>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Jobs;